import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Switch, Route, Redirect } from 'react-router-dom';
import ScriptView from './components/ScriptView';
import ScriptEditor from './components/ScriptEditor';

function Scripts({ match, history, whiteLabel = false }) {
  const config = useSelector((state) => state.config);
  const { acc, pageId } = match.params;
  return (
    <Switch>
      <Route
        exact={true}
        path={`${match.path}/view/:app/:stage?/:page?`}
        render={(p) => {
          const { app, stage, page } = p.match.params;
          return (
            <ScriptView
              acc={acc}
              app={app}
              stage={stage}
              page={page}
              baseUrl={`${match.url}/view`}
              history={history}
              whiteLabel={whiteLabel}
            />
          );
        }}
      />
      <Route
        exact={true}
        path={`${match.path}/view_public/:app/:stage?/:page?`}
        render={(p) => {
          const { app, stage, page } = p.match.params;
          return (
            <ScriptView
              acc={acc}
              app={app}
              stage={stage}
              page={page}
              baseUrl={`${match.url}/view_public`}
              history={history}
              whiteLabel={whiteLabel}
            />
          );
        }}
      />
      <Route
        exact={true}
        path={match.path}
        render={() => {
          const publicScriptParams = config?.hostPublicScript?.split('/') || [];
          const [acc, mode, app, stage] = publicScriptParams;
          if (!acc || !mode || !app || !stage) {
            return <Redirect from={match.path} to="/not_found" />;
          }
          return (
            <ScriptView
              acc={acc}
              app={app}
              stage={stage}
              page={pageId}
              baseUrl={`${match.url}/${mode}`}
              history={history}
              whiteLabel={whiteLabel}
            />
          );
        }}
      />
      <Route
        exact={false}
        path={`${match.path}/edit/:app/:stage?/:page?`}
        render={(p) => (
          <ScriptEditor
            {...p}
            accId={acc}
            id={p.match.params.app}
            history={history}
          />
        )}
      />
    </Switch>
  );
}

Scripts.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  whiteLabel: PropTypes.bool,
};

export default Scripts;
